import DOMPurify from 'dompurify';

// Neutralize links so the viewed email can't navigate, while keeping styling.
// Strips href/target and any inline on* handlers from every element.
const stripInteractivity = (node: Element) => {
    node.removeAttribute('href');
    node.removeAttribute('target');
    for (const attr of [...node.attributes]) {
        if (attr.name.startsWith('on')) node.removeAttribute(attr.name);
    }
};

export const sanitizeEmailHtml = (html: string): string => {
    DOMPurify.addHook('afterSanitizeAttributes', stripInteractivity);
    try {
        return DOMPurify.sanitize(html);
    } finally {
        DOMPurify.removeHook('afterSanitizeAttributes');
    }
};

const escapeForAttribute = (value: string): string =>
    value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

// The new tab shares ORP's origin, so the email renders in a token-less sandbox (an opaque
// origin) that can't reach ORP storage even if markup gets past DOMPurify.
export const buildSandboxedEmailDocument = (emailHtml: string): string =>
    `<!doctype html><html><head><meta charset="utf-8">` +
    `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; ` +
    `style-src 'unsafe-inline'; img-src https: data:; frame-src 'self'">` +
    `<title>Email</title><style>html,body{margin:0;height:100%;}` +
    `iframe{display:block;border:0;width:100%;height:100%;}</style></head>` +
    `<body><iframe sandbox title="Email" srcdoc="${escapeForAttribute(sanitizeEmailHtml(emailHtml))}">` +
    `</iframe></body></html>`;
